/* eslint-disable class-methods-use-this */
import _ from 'lodash';
import * as api from '../../../../utils/apiClient';
import { restructureUserOutputCashModel } from './restructuring';
import { restructurePaginationModel } from '../../../../common/restructuring';

class UserOutputCashService {
  async createOutputCashRequest(state, body) {
    const response = await api.post('/payout/outputs', {}, body);
    const responseJson = await response.json();
    return responseJson;
  }

  async getOutputCashHistory(state, queryParams) {
    const response = await api.get('/payout/outputs/me', queryParams);
    const responseJson = await response.json();
    if (!responseJson.success) {
      return {
        response: responseJson,
        destructData: null
      };
    }
    return {
      response: responseJson,
      destructData: {
        itemsById: _.keyBy(
          _.map(responseJson.data.items, item =>
            restructureUserOutputCashModel(state, item)
          ),
          'id'
        ),
        itemsIds: _.map(responseJson.data.items, item => item.id),
        pagination: restructurePaginationModel(
          _.get(responseJson, 'data._meta')
        )
      }
    };
  }

  async resendCustomerApproveToken(id) {
    const response = await api.post(
      `/payout/outputs/resend-customer-approve-token/${id}`,
      {}
    );
    const responseJson = await response.json();
    return responseJson;
  }

  async customerApprove(token) {
    const response = await api.post(
      `/payout/outputs/customer-approve/${token}`,
      {}
    );
    const responseJson = await response.json();
    return responseJson;
  }

  async customerCancelPayoutOrder(id) {
    const response = await api.post(
      `/payout/outputs/cancel-no-approved-order/${id}`,
      {}
    );
    const responseJson = await response.json();
    return responseJson;
  }
}

export default new UserOutputCashService();



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/authUserOutputCash/services/UserOutputCashService/UserOutputCashService.js